module.exports = __webpack_public_path__ + "img/bg-5.3fdd66a8.png";